import React from 'react'
import { GRADES, getChapters, getLessons } from '../data/curriculum'

// Combobox chọn Lớp → Chương → Bài theo PPCT (cascading).
export interface CurriculumValue {
  lop?: string
  chuong?: string
  bai?: string
}

interface Props {
  value: CurriculumValue
  onChange: (patch: CurriculumValue) => void
  // Khi chọn 1 bài trong PPCT → trả tên bài để gợi ý tiêu đề.
  onPickLesson?: (info: { lop: number; chuong: number; bai: number; ten: string; path: string }) => void
}

const selectCls =
  'w-full p-2.5 border border-gray-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-200 bg-white'

const CurriculumPicker: React.FC<Props> = ({ value, onChange, onPickLesson }) => {
  const lop = value.lop ? Number(value.lop) : undefined
  const chuong = value.chuong ? Number(value.chuong) : undefined

  const chapters = lop ? getChapters(lop) : []
  const lessons = lop && chuong ? getLessons(lop, chuong) : []

  return (
    <div className="grid grid-cols-3 gap-2">
      <div>
        <label className="text-xs font-bold text-gray-500 uppercase">Lớp</label>
        <select
          className={selectCls}
          value={value.lop || ''}
          onChange={(e) => onChange({ lop: e.target.value || undefined, chuong: undefined, bai: undefined })}
        >
          <option value="">—</option>
          {GRADES.map((g) => (
            <option key={g} value={g}>
              Lớp {g}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="text-xs font-bold text-gray-500 uppercase">Chương</label>
        <select
          className={selectCls}
          value={value.chuong || ''}
          disabled={!lop}
          onChange={(e) => onChange({ chuong: e.target.value || undefined, bai: undefined })}
        >
          <option value="">—</option>
          {chapters.map((c) => (
            <option key={c.chuong} value={c.chuong}>
              C{c.chuong}. {c.ten}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="text-xs font-bold text-gray-500 uppercase">Bài</label>
        <select
          className={selectCls}
          value={value.bai || ''}
          disabled={!chuong}
          onChange={(e) => {
            const bai = e.target.value
            onChange({ bai: bai || undefined })
            if (bai && onPickLesson && lop && chuong) {
              const slot = lessons.find((l) => String(l.bai) === bai)
              if (slot) onPickLesson({ lop, chuong, bai: slot.bai, ten: slot.ten, path: slot.path })
            }
          }}
        >
          <option value="">—</option>
          {lessons.map((l) => (
            <option key={l.bai} value={l.bai}>
              Bài {l.bai}. {l.ten}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}

export default CurriculumPicker
